import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scroll to top only on in-app route changes — never on refresh / back-forward.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (navigationType === "POP") {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
